module.exports = "export default __webpack_public_path__ + &quot;1c62c4e3120ccd77727aa142d00c63fa.svg&quot;;"